import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {ProductsModule} from '@app/views/products/products.module';
import {CbFormsModule} from '../../forms.module';
import {MatButtonModule} from '@angular/material/button';
import {CbDialogModule} from '@app/shared/components/dialog/dialog.module';
import {MatIconModule} from '@angular/material/icon';
import {MatFormFieldModule} from '@angular/material/form-field';
import {
    ProductCentreFindComponent
} from '@app/shared/components/forms/individual/product-centre-find/product-centre-find.component';
import {
    ProductCentreFindDialogComponent
} from '@app/shared/components/forms/individual/product-centre-find/product-centre-find-dialog/product-centre-find-dialog.component';


@NgModule({
    declarations: [
        ProductCentreFindDialogComponent,
        ProductCentreFindComponent,
    ],
    exports: [
        ProductCentreFindComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ProductsModule,
        CbFormsModule,
        MatButtonModule,
        CbDialogModule,
        MatIconModule,
        MatFormFieldModule,
    ]
})
export class CbProductCentreFindModule { }